import { render, staticRenderFns } from "./IBHLinkVariableSelection.vue?vue&type=template&id=787bb61e&lang=true"
import script from "./IBHLinkVariableSelection.vue?vue&type=script&lang=js"
export * from "./IBHLinkVariableSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports